import { render } from "./EventForm.vue?vue&type=template&id=6a253583&scoped=true"
import script from "./EventForm.vue?vue&type=script&lang=js"
export * from "./EventForm.vue?vue&type=script&lang=js"

import "./EventForm.vue?vue&type=style&index=0&id=6a253583&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a253583"]])

export default __exports__